import { useState, useEffect, useCallback } from "react";

// ── Constants ─────────────────────────────────────────────────────────────────
const C = { evergreen:"#163C2F", forest:"#214D3A", sage:"#7FB98E", ivory:"#F5F1EA", brass:"#B08D57", charcoal:"#2B2B2B" };
const TABS = [
  { id:"home",        label:"Home",        icon:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> },
  { id:"payments",    label:"Payments",    icon:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg> },
  { id:"maintenance", label:"Maintenance", icon:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg> },
  { id:"documents",   label:"Documents",   icon:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg> },
  { id:"account",     label:"Account",     icon:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg> },
];
const STATUS_COLOR = { paid:"#163C2F", overdue:"#dc2626", unpaid:"#B08D57", open:"#dc2626", in_progress:"#214D3A", resolved:"#163C2F" };

// ── Global CSS ────────────────────────────────────────────────────────────────
const CSS = `
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
  html{font-family:'Manrope',sans-serif;background:${C.ivory};color:${C.charcoal};-webkit-font-smoothing:antialiased;}
  .tp-nav{position:fixed;top:0;left:0;right:0;height:56px;background:${C.evergreen};display:flex;align-items:center;padding:0 16px;gap:12px;z-index:40;border-bottom:1px solid rgba(255,255,255,0.08);}
  .tp-hamburger{width:36px;height:36px;display:flex;align-items:center;justify-content:center;background:none;border:none;color:rgba(245,241,234,0.6);cursor:pointer;border-radius:6px;flex-shrink:0;transition:background 0.12s,color 0.12s;}
  .tp-hamburger:hover{background:rgba(255,255,255,0.08);color:#F5F1EA;}
  .tp-nav-logo{display:flex;align-items:center;gap:8px;flex-shrink:0;}
  .tp-nav-logo-name{font-family:'Cormorant Garamond',serif;font-size:20px;font-weight:700;color:#F5F1EA;letter-spacing:0.02em;line-height:1;}
  .tp-portal-badge{background:rgba(127,185,142,0.18);border:1px solid rgba(127,185,142,0.3);color:${C.sage};font-size:9px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;padding:2px 9px;border-radius:50px;flex-shrink:0;}
  .tp-nav-right{display:flex;align-items:center;gap:10px;margin-left:auto;}
  .tp-tenant-name{font-size:13px;color:rgba(245,241,234,0.7);font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:140px;}
  .tp-signout{background:none;border:1px solid rgba(245,241,234,0.2);color:rgba(245,241,234,0.5);font-family:'Manrope',sans-serif;font-size:11px;font-weight:600;padding:5px 12px;border-radius:50px;cursor:pointer;transition:all 0.15s;white-space:nowrap;}
  .tp-signout:hover{border-color:rgba(245,241,234,0.5);color:#F5F1EA;}
  .tp-sidebar{position:fixed;left:0;top:56px;bottom:0;width:200px;background:#fff;border-right:1px solid #E8E4DC;transform:translateX(-100%);transition:transform 0.2s ease;z-index:35;overflow-y:auto;padding:8px 0;}
  .tp-sidebar.open{transform:translateX(0);}
  .tp-sbi{display:flex;align-items:center;gap:10px;padding:10px 16px;cursor:pointer;font-size:13px;font-weight:500;color:${C.charcoal};transition:background 0.12s,color 0.12s;border-left:3px solid transparent;}
  .tp-sbi:hover{background:${C.ivory};}
  .tp-sbi.active{background:#EAF2ED;color:${C.evergreen};border-left-color:${C.evergreen};font-weight:700;}
  .tp-main{margin-top:56px;padding:24px 20px 100px;max-width:720px;margin-left:auto;margin-right:auto;}
  @media(min-width:769px){.tp-main{padding:28px 32px 40px;}.tp-sidebar.open~.tp-main{margin-left:200px;}}
  .tp-mobile-nav{display:none;position:fixed;bottom:0;left:0;right:0;height:60px;background:${C.evergreen};border-top:1px solid rgba(255,255,255,0.1);z-index:40;}
  .tp-mob-items{display:flex;height:100%;}
  .tp-mob-item{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:3px;background:none;border:none;color:rgba(245,241,234,0.4);font-family:'Manrope',sans-serif;font-size:9px;font-weight:600;cursor:pointer;transition:color 0.15s;padding:4px 2px;}
  .tp-mob-item.active{color:${C.sage};}
  @media(max-width:768px){.tp-mobile-nav{display:block;}.tp-main{padding:20px 16px 76px;}}
  .tp-h2{font-family:'DM Serif Display',serif;font-size:24px;font-weight:400;color:${C.evergreen};margin-bottom:18px;}
  .tp-card{background:#fff;border:1px solid #E8E4DC;border-radius:12px;padding:20px 22px;}
  .tp-label{font-size:10px;font-weight:700;color:#9B9690;text-transform:uppercase;letter-spacing:0.1em;}
  .tp-inp{width:100%;padding:10px 13px;font-size:14px;border:1px solid #D4CFC7;border-radius:8px;outline:none;font-family:'Manrope',sans-serif;background:#fff;color:${C.charcoal};transition:border-color 0.15s;}
  .tp-inp:focus{border-color:${C.sage};}
  .tp-btn-green{background:${C.evergreen};color:#F5F1EA;border:none;border-radius:999px;padding:11px 24px;font-family:'Manrope',sans-serif;font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;cursor:pointer;transition:background 0.15s;}
  .tp-btn-green:hover{background:${C.forest};}
  .tp-btn-green:disabled{background:#9B9690;cursor:not-allowed;}
  .tp-btn-sage{background:${C.sage};color:${C.evergreen};border:none;border-radius:999px;padding:11px 24px;font-family:'Manrope',sans-serif;font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;cursor:pointer;transition:background 0.15s;}
  .tp-btn-outline{background:transparent;color:${C.evergreen};border:1.5px solid ${C.evergreen};border-radius:999px;padding:8px 18px;font-family:'Manrope',sans-serif;font-size:12px;font-weight:600;cursor:pointer;transition:background 0.15s;}
  .tp-btn-outline:hover{background:rgba(22,60,47,0.06);}
  .tp-badge{padding:2px 10px;border-radius:999px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.04em;}
  .tp-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:50;display:flex;align-items:flex-end;justify-content:center;}
  @media(min-width:600px){.tp-overlay{align-items:center;}}
  .tp-modal{background:#fff;border-radius:16px 16px 0 0;padding:28px 24px;width:100%;max-width:480px;max-height:85vh;overflow-y:auto;}
  @media(min-width:600px){.tp-modal{border-radius:16px;}}
  .tp-modal-h{font-family:'DM Serif Display',serif;font-size:22px;font-weight:400;color:${C.charcoal};margin-bottom:16px;}
  .tp-select{width:100%;padding:10px 13px;font-size:14px;border:1px solid #D4CFC7;border-radius:8px;outline:none;font-family:'Manrope',sans-serif;background:#fff;color:${C.charcoal};}
  .tp-textarea{width:100%;padding:10px 13px;font-size:14px;border:1px solid #D4CFC7;border-radius:8px;outline:none;font-family:'Manrope',sans-serif;background:#fff;color:${C.charcoal};resize:vertical;}
`;

// ── Helpers ───────────────────────────────────────────────────────────────────
const fmtDate = d => d ? new Date(d + "T00:00:00").toLocaleDateString("en-US", { month:"short", day:"numeric", year:"numeric" }) : "—";
const fmtMoney = n => "$" + Number(n||0).toLocaleString();
const greeting = () => { const h = new Date().getHours(); return h < 12 ? "Good morning" : h < 17 ? "Good afternoon" : "Good evening"; };
const Badge = ({ label, color }) => (
  <span className="tp-badge" style={{ background: color + "18", color, border: `1px solid ${color}33` }}>{label}</span>
);

// ── Receipt printer ───────────────────────────────────────────────────────────
function printReceipt(p, company) {
  const w = window.open("", "_blank", "width=580,height=760");
  w.document.write(`<!DOCTYPE html><html><head><title>Receipt</title><style>
    body{font-family:Arial,sans-serif;padding:40px;color:#2B2B2B;max-width:520px;margin:0 auto;}
    h1{color:#163C2F;font-size:22px;margin-bottom:4px;}
    .sub{color:#9B9690;font-size:12px;margin-bottom:28px;}
    .row{display:flex;justify-content:space-between;padding:10px 0;border-bottom:1px solid #F5F1EA;font-size:13px;}
    .lbl{color:#9B9690;}.val{font-weight:600;}
    .pill{display:inline-block;padding:2px 10px;border-radius:999px;font-size:10px;font-weight:700;text-transform:uppercase;background:#EAF2ED;color:#163C2F;}
    @media print{button{display:none;}}
    button{margin-top:24px;padding:10px 24px;background:#163C2F;color:#fff;border:none;border-radius:50px;cursor:pointer;font-size:12px;font-weight:700;}
  </style></head><body>
    <h1>Payment Receipt</h1>
    <div class="sub">${company?.company_name || "Leasly Property Management"}</div>
    <div class="row"><span class="lbl">Tenant</span><span class="val">${p.tenant}</span></div>
    <div class="row"><span class="lbl">Amount</span><span class="val">${fmtMoney(p.amount)}</span></div>
    ${p.late_fee > 0 ? `<div class="row"><span class="lbl">Late Fee</span><span class="val">${fmtMoney(p.late_fee)}</span></div>` : ""}
    <div class="row"><span class="lbl">Due Date</span><span class="val">${fmtDate(p.due)}</span></div>
    <div class="row"><span class="lbl">Paid Date</span><span class="val">${fmtDate(p.paid)}</span></div>
    <div class="row"><span class="lbl">Method</span><span class="val">${p.payment_method || p.method || "—"}</span></div>
    ${p.invoice_number ? `<div class="row"><span class="lbl">Invoice #</span><span class="val">${p.invoice_number}</span></div>` : ""}
    <div class="row"><span class="lbl">Status</span><span class="val"><span class="pill">${p.status}</span></span></div>
    <button onclick="window.print()">Print / Save PDF</button>
  </body></html>`);
  w.document.close();
}

// ── Main component ────────────────────────────────────────────────────────────
export default function TenantPortal({ supabase, session }) {
  const [tab,         setTab]         = useState(() => {
    const t = new URLSearchParams(window.location.search).get("tab");
    return t && ["home","payments","maintenance","documents","account"].includes(t) ? t : "home";
  });
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [portalData,  setPortalData]  = useState(null);
  const [loading,     setLoading]     = useState(true);
  const [error,       setError]       = useState("");
  const [expiredBanner, setExpiredBanner] = useState(() => {
    const p = new URLSearchParams(window.location.search);
    if (p.get("expired") === "1") {
      window.history.replaceState({}, "", window.location.pathname + (p.get("tab") ? `?tab=${p.get("tab")}` : ""));
      return true;
    }
    return false;
  });

  const loadData = async () => {
    setLoading(true);
    const { data, error } = await supabase.rpc("get_tenant_portal_data");
    setLoading(false);
    if (error) { setError(error.message || "Failed to load portal data."); return; }
    setPortalData(data);
  };

  useEffect(() => { loadData(); }, []);

  const signOut = async () => { await supabase.auth.signOut(); window.location.href = "/"; };

  const tenantName = portalData?.tenant?.name || session?.user?.user_metadata?.full_name || session?.user?.email?.split("@")[0] || "Tenant";

  const navProps = { tab, setTab, sidebarOpen, setSidebarOpen, tenantName, signOut };

  if (loading) return (
    <div style={{ minHeight:"100vh", background:C.ivory, display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:16 }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=Cormorant+Garamond:wght@400;700&family=Manrope:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
      <style>{CSS}</style>
      <style>{`@keyframes spin{to{transform:rotate(360deg);}}`}</style>
      <div style={{ width:28, height:28, border:"3px solid #E8E4DC", borderTop:`3px solid ${C.evergreen}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }}/>
      <div style={{ fontSize:14, color:"#9B9690", fontFamily:"'Manrope',sans-serif" }}>Loading your portal…</div>
    </div>
  );

  if (error) return (
    <div style={{ minHeight:"100vh", background:C.ivory, display:"flex", alignItems:"center", justifyContent:"center", padding:32 }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=Cormorant+Garamond:wght@400;700&family=Manrope:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
      <style>{CSS}</style>
      <div style={{ textAlign:"center", maxWidth:400 }}>
        <div style={{ fontSize:36, marginBottom:16 }}>⚠️</div>
        <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:22, color:C.charcoal, marginBottom:10 }}>{error}</h2>
        <button onClick={loadData} className="tp-btn-green">Retry</button>
        <button onClick={signOut} style={{ marginLeft:10, background:"none", border:"none", color:"#9B9690", cursor:"pointer", fontSize:13, fontFamily:"'Manrope',sans-serif" }}>Sign out</button>
      </div>
    </div>
  );

  const { tenant, payments, maintenance, documents, company } = portalData;

  const contentProps = { tenant, payments, maintenance, documents, company, supabase, reloadData: loadData };

  return (
    <div style={{ fontFamily:"'Manrope',sans-serif", background:C.ivory, minHeight:"100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=Cormorant+Garamond:wght@400;700&family=Manrope:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
      <style>{CSS}</style>

      <PortalNav {...navProps}/>

      <nav className={`tp-sidebar${sidebarOpen ? " open" : ""}`}>
        {TABS.map(t => (
          <div key={t.id} className={`tp-sbi${tab === t.id ? " active" : ""}`}
            onClick={() => { setTab(t.id); setSidebarOpen(false); }}>
            <span style={{ color: tab === t.id ? C.evergreen : "#9B9690" }}>{t.icon}</span>
            {t.label}
          </div>
        ))}
      </nav>

      {sidebarOpen && <div onClick={() => setSidebarOpen(false)} style={{ position:"fixed", inset:0, zIndex:34 }}/>}

      <main className="tp-main">
        {expiredBanner && (
          <div style={{ background:"#FEF9EE", border:"1px solid #B08D5744", borderRadius:10, padding:"12px 16px", marginBottom:20, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12 }}>
            <div style={{ fontSize:13, color:"#92400E", lineHeight:1.5 }}>
              Your payment link has expired. You can start a new payment below.
            </div>
            <button onClick={() => setExpiredBanner(false)} style={{ background:"none", border:"none", color:"#9B9690", cursor:"pointer", fontSize:16, lineHeight:1, padding:4, flexShrink:0 }}>✕</button>
          </div>
        )}
        {tab === "home"        && <HomeTab        {...contentProps}/>}
        {tab === "payments"    && <PaymentsTab    {...contentProps}/>}
        {tab === "maintenance" && <MaintenanceTab {...contentProps}/>}
        {tab === "documents"   && <DocumentsTab   {...contentProps}/>}
        {tab === "account"     && <AccountTab     {...contentProps} session={session}/>}
      </main>

      <div className="tp-mobile-nav">
        <div className="tp-mob-items">
          {TABS.map(t => (
            <button key={t.id} className={`tp-mob-item${tab === t.id ? " active" : ""}`} onClick={() => setTab(t.id)}>
              {t.icon}
              <span>{t.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── Top navbar ────────────────────────────────────────────────────────────────
function PortalNav({ sidebarOpen, setSidebarOpen, tenantName, signOut }) {
  return (
    <div className="tp-nav">
      <button className="tp-hamburger" onClick={() => setSidebarOpen(s => !s)} title="Menu">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
      </button>
      <div className="tp-nav-logo">
        <img src="/Leasly-logofinal.png" alt="Leasly" width="26" height="26" style={{ borderRadius:5, objectFit:"contain" }}/>
        <div>
          <div className="tp-nav-logo-name">Leasly</div>
        </div>
      </div>
      <span className="tp-portal-badge">Tenant Portal</span>
      <div className="tp-nav-right">
        <span className="tp-tenant-name">{tenantName}</span>
        <button className="tp-signout" onClick={signOut}>Sign out</button>
      </div>
    </div>
  );
}

// ── HOME tab ──────────────────────────────────────────────────────────────────
function HomeTab({ tenant, payments, maintenance, company, supabase }) {
  const [message,    setMessage]    = useState("");
  const [msgSent,    setMsgSent]    = useState(false);
  const [payingId,   setPayingId]   = useState(null);
  const [payError,   setPayError]   = useState(null);

  const handlePayRent = async (paymentId) => {
    setPayingId(paymentId);
    setPayError(null);
    try {
      const { data, error } = await supabase.functions.invoke("create-rent-checkout", {
        body: { payment_id: paymentId },
      });
      const errMsg = data?.error || error?.message;
      if (errMsg || !data?.url) {
        if (errMsg === "CONNECT_NOT_READY") {
          setPayError("Online payment isn't set up for this property yet. Please contact your landlord.");
        } else if (errMsg?.toLowerCase().includes("already marked as paid") || errMsg?.toLowerCase().includes("already been made")) {
          setPayError("This payment has already been made. Please contact your landlord if you have questions.");
        } else {
          setPayError(errMsg || "Something went wrong. Please try again.");
        }
        return;
      }
      window.location.href = data.url;
    } catch (err) {
      setPayError(String(err));
    } finally {
      setPayingId(null);
    }
  };

  const now        = new Date();
  const yearStr    = String(now.getFullYear());
  const nextPmt    = payments.find(p => p.status !== "paid");
  const latestPaid = payments.find(p => p.status === "paid");
  const recentMaint= maintenance.slice(0, 3);

  const sendMessage = () => {
    if (!message.trim()) return;
    const addr = company?.email || "support@leaslypro.com";
    window.open(`mailto:${addr}?subject=Message from ${tenant.name}&body=${encodeURIComponent(message)}`, "_blank");
    setMsgSent(true);
    setMessage("");
    setTimeout(() => setMsgSent(false), 3000);
  };

  const leaseDays = tenant.lease_end
    ? Math.ceil((new Date(tenant.lease_end + "T00:00:00") - now) / 86400000)
    : null;

  return (
    <div>
      {/* Greeting */}
      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontFamily:"'DM Serif Display',serif", fontSize:28, fontWeight:400, color:C.evergreen, marginBottom:4 }}>
          {greeting()}, {tenant.name?.split(" ")[0]}.
        </h1>
        <div style={{ fontSize:13, color:"#9B9690" }}>Here's your tenant overview.</div>
      </div>

      {/* Rent card */}
      <div style={{ background:C.evergreen, borderRadius:14, padding:"24px 26px", marginBottom:16, color:"#F5F1EA" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:20 }}>
          <div>
            <div style={{ fontSize:10, color:"rgba(245,241,234,0.5)", textTransform:"uppercase", letterSpacing:"0.1em", fontWeight:600, marginBottom:6 }}>Monthly Rent</div>
            <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:40, fontWeight:400, lineHeight:1 }}>
              {fmtMoney(tenant.rent)}
            </div>
            <div style={{ fontSize:13, color:"rgba(245,241,234,0.55)", marginTop:6 }}>
              {nextPmt ? `Due ${fmtDate(nextPmt.due)}` : latestPaid ? `Last paid ${fmtDate(latestPaid.paid)}` : "No upcoming payments"}
            </div>
          </div>
          <div style={{ textAlign:"right" }}>
            {nextPmt ? (
              <span style={{ background: nextPmt.status === "overdue" ? "#dc262622" : "rgba(127,185,142,0.18)", color: nextPmt.status === "overdue" ? "#fca5a5" : C.sage, border: `1px solid ${nextPmt.status === "overdue" ? "#dc262644" : "rgba(127,185,142,0.35)"}`, padding:"4px 12px", borderRadius:999, fontSize:11, fontWeight:700, textTransform:"uppercase" }}>
                {nextPmt.status}
              </span>
            ) : (
              <span style={{ background:"rgba(127,185,142,0.18)", color:C.sage, border:"1px solid rgba(127,185,142,0.35)", padding:"4px 12px", borderRadius:999, fontSize:11, fontWeight:700 }}>
                All Paid
              </span>
            )}
          </div>
        </div>
        {nextPmt && (
          <button className="tp-btn-sage" onClick={() => handlePayRent(nextPmt.id)} disabled={payingId === nextPmt.id} style={{ width:"100%", opacity: payingId === nextPmt.id ? 0.6 : 1 }}>
            {payingId === nextPmt.id ? "Loading…" : "Pay Rent"}
          </button>
        )}
        {payError && (
          <div style={{ marginTop:10, padding:"10px 14px", background:"#fef2f2", border:"1px solid #fca5a5", borderRadius:8, fontSize:12, color:"#dc2626", lineHeight:1.5 }}>
            {payError}
          </div>
        )}
      </div>

      {/* Info cards */}
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div className="tp-card">
          <div className="tp-label" style={{ marginBottom:8 }}>Lease Period</div>
          <div style={{ fontSize:13, fontWeight:600, color:C.charcoal }}>
            {tenant.lease_start ? fmtDate(tenant.lease_start) : "—"}<br/>
            <span style={{ fontWeight:400, color:"#9B9690" }}>to</span><br/>
            {tenant.lease_end ? fmtDate(tenant.lease_end) : "Month-to-Month"}
          </div>
          {leaseDays !== null && leaseDays <= 90 && (
            <div style={{ marginTop:8, fontSize:11, fontWeight:600, color: leaseDays <= 30 ? "#dc2626" : C.brass }}>
              {leaseDays <= 0 ? "Lease expired" : `${leaseDays} days remaining`}
            </div>
          )}
        </div>
        <div className="tp-card">
          <div className="tp-label" style={{ marginBottom:8 }}>Property</div>
          <div style={{ fontSize:13, fontWeight:600, color:C.charcoal }}>{tenant.address || "—"}</div>
          {tenant.property && <div style={{ fontSize:12, color:"#9B9690", marginTop:4 }}>{tenant.property}</div>}
          {tenant.city && <div style={{ fontSize:12, color:"#9B9690" }}>{tenant.city}{tenant.state ? `, ${tenant.state}` : ""}</div>}
        </div>
      </div>

      {/* Recent maintenance */}
      {recentMaint.length > 0 && (
        <div className="tp-card" style={{ marginBottom:16 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
            <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:17, color:C.evergreen }}>Recent Tickets</div>
          </div>
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {recentMaint.map((m, i) => (
              <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 10px", background:C.ivory, borderRadius:8 }}>
                <div>
                  <div style={{ fontSize:13, fontWeight:600, color:C.charcoal }}>{m.issue}</div>
                  <div style={{ fontSize:11, color:"#9B9690" }}>{fmtDate(m.date)}</div>
                </div>
                <Badge label={m.status} color={STATUS_COLOR[m.status] || "#9B9690"}/>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Message landlord */}
      <div className="tp-card">
        <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:17, color:C.evergreen, marginBottom:12 }}>Message Your Landlord</div>
        <textarea
          className="tp-textarea"
          rows={3}
          value={message}
          onChange={e => setMessage(e.target.value)}
          placeholder="Type your message…"
          style={{ marginBottom:10 }}
        />
        {msgSent && <div style={{ fontSize:12, color:"#22c55e", marginBottom:8 }}>✓ Opening email…</div>}
        <button className="tp-btn-green" onClick={sendMessage}>Send Message</button>
        {company?.email && <div style={{ fontSize:11, color:"#9B9690", marginTop:8 }}>or email directly: {company.email}</div>}
      </div>

    </div>
  );
}

// ── PAYMENTS tab ──────────────────────────────────────────────────────────────
function PaymentsTab({ payments, company, tenant, supabase }) {
  const [filterYr, setFilterYr] = useState(String(new Date().getFullYear()));
  const [payingId, setPayingId] = useState(null);
  const [payError, setPayError] = useState(null);

  const handlePayRent = async (paymentId) => {
    setPayingId(paymentId);
    setPayError(null);
    try {
      const { data, error } = await supabase.functions.invoke("create-rent-checkout", {
        body: { payment_id: paymentId },
      });
      const errMsg = data?.error || error?.message;
      if (errMsg || !data?.url) {
        if (errMsg === "CONNECT_NOT_READY") {
          setPayError("Online payment isn't set up for this property yet. Please contact your landlord.");
        } else if (errMsg?.toLowerCase().includes("already marked as paid") || errMsg?.toLowerCase().includes("already been made")) {
          setPayError("This payment has already been made. Please contact your landlord if you have questions.");
        } else {
          setPayError(errMsg || "Something went wrong. Please try again.");
        }
        return;
      }
      window.location.href = data.url;
    } catch (err) {
      setPayError(String(err));
    } finally {
      setPayingId(null);
    }
  };
  const [filterMo, setFilterMo] = useState("");

  const now    = new Date();
  const yearStr = String(now.getFullYear());
  const paidYTD    = payments.filter(p => p.status === "paid" && p.paid?.startsWith(yearStr)).reduce((s,p) => s + (p.amount||0), 0);
  const lateFeesYTD = payments.filter(p => p.paid?.startsWith(yearStr)).reduce((s,p) => s + (p.late_fee||0), 0);
  const nextPmt    = payments.find(p => p.status !== "paid");
  const overdue    = payments.filter(p => p.status === "overdue").reduce((s,p) => s + (p.amount||0), 0);

  const filtered = payments.filter(p => {
    if (filterYr && !((p.due||"").startsWith(filterYr))) return false;
    if (filterMo && !((p.due||"").startsWith(`${filterYr}-${filterMo}`))) return false;
    return true;
  });

  const years = [...new Set(payments.map(p => (p.due||"").slice(0,4)).filter(Boolean))].sort((a,b) => b-a);

  const nextDueLabel = nextPmt
    ? new Date(nextPmt.due + "T00:00:00").toLocaleDateString("en-US", { month:"short", day:"numeric" })
    : "—";

  const badgeStyle = (status) => {
    if (status === "paid")    return { background:"#EAF3DE", color:"#3B6D11", border:"1px solid #3B6D1122" };
    if (status === "overdue") return { background:"#FCEBEB", color:"#A32D2D", border:"1px solid #A32D2D22" };
    return                           { background:"#FAEEDA", color:"#854F0B", border:"1px solid #854F0B22" };
  };

  return (
    <div>
      <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:28, fontWeight:400, color:"#163C2F", marginBottom:20 }}>Payments</h2>

      {/* ── Summary cards ── */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:12, marginBottom:20 }}>
        {/* Paid this year */}
        <div style={{ background:"#fff", border:"0.5px solid #E8E4DC", borderRadius:12, padding:"20px 22px" }}>
          <div style={{ fontSize:11, color:"#9B9690", textTransform:"uppercase", letterSpacing:"0.08em", fontWeight:600, marginBottom:10 }}>Paid this year</div>
          <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:24, color:"#163C2F" }}>{fmtMoney(paidYTD)}</div>
        </div>
        {/* Late fees YTD */}
        <div style={{ background:"#fff", border:"0.5px solid #E8E4DC", borderRadius:12, padding:"20px 22px" }}>
          <div style={{ fontSize:11, color:"#9B9690", textTransform:"uppercase", letterSpacing:"0.08em", fontWeight:600, marginBottom:10 }}>Late fees YTD</div>
          <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:24, color:"#A6802C" }}>{fmtMoney(lateFeesYTD)}</div>
        </div>
        {/* Next due */}
        <div style={{ background:"#fff", border:"0.5px solid #E8E4DC", borderRadius:12, padding:"20px 22px" }}>
          <div style={{ fontSize:11, color:"#9B9690", textTransform:"uppercase", letterSpacing:"0.08em", fontWeight:600, marginBottom:10 }}>Next due</div>
          <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:24, color:"#163C2F" }}>{nextDueLabel}</div>
          {nextPmt && <div style={{ fontSize:12, color:"#9B9690", marginTop:4 }}>{fmtMoney(nextPmt.amount)} due</div>}
        </div>
      </div>

      {/* ── Pay rent CTA ── */}
      {nextPmt ? (
        <div style={{ background:"#163C2F", borderRadius:14, padding:"24px 28px", marginBottom: payError ? 10 : 24, display:"flex", alignItems:"center", justifyContent:"space-between", gap:20, flexWrap:"wrap" }}>
          <div>
            <div style={{ fontSize:11, color:"#7FB98E", textTransform:"uppercase", letterSpacing:"0.1em", fontWeight:600, marginBottom:6 }}>Amount due</div>
            <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:36, color:"#F5F1EA", lineHeight:1 }}>{fmtMoney(nextPmt.amount)}</div>
            <div style={{ fontSize:13, color:"#7FB98E", marginTop:8 }}>Due {fmtDate(nextPmt.due)}</div>
          </div>
          <button
            onClick={() => handlePayRent(nextPmt.id)}
            disabled={payingId === nextPmt.id}
            style={{
              background:"#7FB98E", color:"#163C2F", border:"none", borderRadius:999,
              padding:"14px 36px", fontWeight:700, fontSize:14, cursor:"pointer",
              fontFamily:"'Manrope',sans-serif", letterSpacing:"0.04em",
              opacity: payingId === nextPmt.id ? 0.6 : 1, whiteSpace:"nowrap",
              transition:"opacity 0.15s",
            }}
          >
            {payingId === nextPmt.id ? "Loading…" : "Pay rent"}
          </button>
        </div>
      ) : (
        <div style={{ background:"#EAF3DE", border:"1px solid #3B6D1122", borderRadius:12, padding:"16px 22px", marginBottom:24, display:"flex", alignItems:"center", gap:10 }}>
          <span style={{ fontSize:18 }}>✓</span>
          <span style={{ fontSize:14, fontWeight:600, color:"#3B6D11" }}>All caught up — no payments due.</span>
        </div>
      )}

      {/* Error */}
      {payError && (
        <div style={{ padding:"12px 16px", background:"#fef2f2", border:"1px solid #fca5a5", borderRadius:10, fontSize:13, color:"#dc2626", lineHeight:1.5, marginBottom:24 }}>
          {payError}
        </div>
      )}

      {/* ── Filters ── */}
      <div style={{ display:"flex", gap:10, marginBottom:16, flexWrap:"wrap" }}>
        <select className="tp-select" style={{ flex:1, minWidth:100 }} value={filterYr} onChange={e => setFilterYr(e.target.value)}>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <select className="tp-select" style={{ flex:1, minWidth:100 }} value={filterMo} onChange={e => setFilterMo(e.target.value)}>
          <option value="">All months</option>
          {["01","02","03","04","05","06","07","08","09","10","11","12"].map((m,i) => (
            <option key={m} value={m}>{new Date(2000,i).toLocaleString("en-US",{month:"long"})}</option>
          ))}
        </select>
      </div>

      {/* ── Payment history ── */}
      <div style={{ background:"#fff", border:"0.5px solid #E8E4DC", borderRadius:12, overflow:"hidden" }}>
        {filtered.length === 0 ? (
          <div style={{ padding:"40px 20px", textAlign:"center", color:"#9B9690", fontSize:14 }}>No payments found for this period.</div>
        ) : filtered.map((p, i) => {
          const bs = badgeStyle(p.status);
          return (
            <div key={p.id || i} style={{ padding:"16px 20px", borderBottom: i < filtered.length-1 ? "1px solid #F5F1EA" : "none", display:"flex", justifyContent:"space-between", alignItems:"center", gap:14 }}>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontWeight:700, fontSize:15, color:"#2B2B2B" }}>{fmtMoney(p.amount)}</div>
                <div style={{ fontSize:12, color:"#9B9690", marginTop:3 }}>
                  Due {fmtDate(p.due)}
                  {p.paid ? ` · Paid ${fmtDate(p.paid)}` : ""}
                  {p.payment_method ? ` · ${p.payment_method}` : ""}
                  {p.late_fee > 0 && <span style={{ color:"#A6802C" }}> · includes {fmtMoney(p.late_fee)} late fee</span>}
                </div>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:10, flexShrink:0 }}>
                <span style={{ ...bs, padding:"3px 11px", borderRadius:999, fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.04em" }}>
                  {p.status}
                </span>
                {p.status === "paid" && (
                  <button onClick={() => printReceipt(p, company)} style={{
                    background:"transparent", color:"#163C2F", border:"1.5px solid #163C2F",
                    borderRadius:999, padding:"5px 14px", fontSize:11, fontWeight:600,
                    cursor:"pointer", fontFamily:"'Manrope',sans-serif", whiteSpace:"nowrap",
                  }}>
                    Receipt
                  </button>
                )}
                {(p.status === "unpaid" || p.status === "overdue") && (
                  <button onClick={() => handlePayRent(p.id)} disabled={payingId === p.id} style={{
                    background:"#163C2F", color:"#F5F1EA", border:"none",
                    borderRadius:999, padding:"6px 16px", fontSize:11, fontWeight:700,
                    cursor:"pointer", fontFamily:"'Manrope',sans-serif", whiteSpace:"nowrap",
                    opacity: payingId === p.id ? 0.6 : 1,
                  }}>
                    {payingId === p.id ? "Loading…" : "Pay now"}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── MAINTENANCE tab ───────────────────────────────────────────────────────────
function MaintenanceTab({ maintenance, supabase, reloadData, tenant }) {
  const [showForm, setShowForm] = useState(false);
  const [form,     setForm]     = useState({ issue:"", notes:"", priority:"medium", category:"General" });
  const [saving,   setSaving]   = useState(false);
  const [err,      setErr]      = useState("");

  const open     = maintenance.filter(m => m.status !== "resolved");
  const resolved = maintenance.filter(m => m.status === "resolved");

  const submit = async () => {
    if (!form.issue.trim()) { setErr("Please enter a title."); return; }
    setSaving(true); setErr("");
    const { error } = await supabase.rpc("submit_tenant_maintenance", {
      p_issue:    form.issue,
      p_notes:    form.notes || null,
      p_priority: form.priority,
      p_category: form.category,
    });
    setSaving(false);
    if (error) { setErr(error.message); return; }
    if (tenant?.user_id) {
      supabase.from("notifications").insert([{
        user_id: tenant.user_id, type: "maintenance",
        message: `${tenant.name || "A tenant"} submitted a maintenance request: ${form.issue}`,
        link: "Maintenance",
      }]).then(() => {});
    }
    setShowForm(false);
    setForm({ issue:"", notes:"", priority:"medium", category:"General" });
    reloadData();
  };

  const TicketRow = ({ m }) => (
    <div style={{ padding:"12px 16px", borderBottom:"1px solid #F5F1EA", display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12 }}>
      <div style={{ flex:1 }}>
        <div style={{ fontWeight:600, fontSize:13, color:C.charcoal, marginBottom:3 }}>{m.issue}</div>
        <div style={{ fontSize:11, color:"#9B9690" }}>{m.category} · {fmtDate(m.date)}{m.priority && ` · ${m.priority}`}</div>
        {m.notes && <div style={{ fontSize:12, color:"#9B9690", marginTop:4, fontStyle:"italic" }}>{m.notes}</div>}
      </div>
      <Badge label={m.status === "in_progress" ? "In Progress" : m.status} color={STATUS_COLOR[m.status] || "#9B9690"}/>
    </div>
  );

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
        <h2 className="tp-h2" style={{ marginBottom:0 }}>Maintenance</h2>
        <button className="tp-btn-green" onClick={() => setShowForm(s => !s)}>
          {showForm ? "Cancel" : "+ New Request"}
        </button>
      </div>

      {showForm && (
        <div className="tp-card" style={{ marginBottom:20 }}>
          <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:18, color:C.evergreen, marginBottom:16 }}>Submit a Request</div>
          <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
            <div>
              <div className="tp-label" style={{ marginBottom:6 }}>Issue Title *</div>
              <input className="tp-inp" placeholder="e.g. Kitchen faucet leaking" value={form.issue} onChange={e => setForm(s => ({...s, issue:e.target.value}))}/>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
              <div>
                <div className="tp-label" style={{ marginBottom:6 }}>Category</div>
                <select className="tp-select" value={form.category} onChange={e => setForm(s => ({...s, category:e.target.value}))}>
                  {["General","Plumbing","Electrical","HVAC","Appliances","Pest Control","Structural","Other"].map(c => <option key={c}>{c}</option>)}
                </select>
              </div>
              <div>
                <div className="tp-label" style={{ marginBottom:6 }}>Priority</div>
                <select className="tp-select" value={form.priority} onChange={e => setForm(s => ({...s, priority:e.target.value}))}>
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High — urgent</option>
                </select>
              </div>
            </div>
            <div>
              <div className="tp-label" style={{ marginBottom:6 }}>Description (optional)</div>
              <textarea className="tp-textarea" rows={3} placeholder="Describe the issue in detail…" value={form.notes} onChange={e => setForm(s => ({...s, notes:e.target.value}))}/>
            </div>
            {err && <div style={{ fontSize:13, color:"#dc2626" }}>{err}</div>}
            <button className="tp-btn-green" onClick={submit} disabled={saving}>{saving ? "Submitting…" : "Submit Request"}</button>
          </div>
        </div>
      )}

      {/* Open tickets */}
      <div className="tp-card" style={{ padding:0, overflow:"hidden", marginBottom:16 }}>
        <div style={{ padding:"14px 16px", borderBottom:"1px solid #F5F1EA", display:"flex", justifyContent:"space-between" }}>
          <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:17, color:C.evergreen }}>Open Tickets</div>
          <span style={{ fontSize:12, fontWeight:700, color:"#dc2626" }}>{open.length}</span>
        </div>
        {open.length === 0
          ? <div style={{ padding:"24px 16px", textAlign:"center", color:"#9B9690", fontSize:14 }}>No open tickets. ✓</div>
          : open.map((m,i) => <TicketRow key={i} m={m}/>)}
      </div>

      {/* Resolved */}
      {resolved.length > 0 && (
        <div className="tp-card" style={{ padding:0, overflow:"hidden" }}>
          <div style={{ padding:"14px 16px", borderBottom:"1px solid #F5F1EA" }}>
            <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:17, color:"#9B9690" }}>Resolved ({resolved.length})</div>
          </div>
          {resolved.slice(0, 10).map((m,i) => <TicketRow key={i} m={m}/>)}
        </div>
      )}
    </div>
  );
}

// ── DOCUMENTS tab ─────────────────────────────────────────────────────────────
function DocumentsTab({ documents }) {
  if (documents.length === 0) return (
    <div>
      <h2 className="tp-h2">Documents</h2>
      <div className="tp-card" style={{ textAlign:"center", padding:"48px 20px", color:"#9B9690" }}>
        <div style={{ fontSize:32, marginBottom:12 }}>📄</div>
        <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:18, color:C.charcoal, marginBottom:8 }}>No documents yet</div>
        <div style={{ fontSize:13 }}>Your landlord will share documents here when available.</div>
      </div>
    </div>
  );

  return (
    <div>
      <h2 className="tp-h2">Documents</h2>
      <div className="tp-card" style={{ padding:0, overflow:"hidden" }}>
        {documents.map((d, i) => (
          <div key={i} style={{ padding:"14px 18px", borderBottom: i < documents.length-1 ? "1px solid #F5F1EA":"none", display:"flex", justifyContent:"space-between", alignItems:"center", gap:12 }}>
            <div>
              <div style={{ fontWeight:600, fontSize:13, color:C.charcoal, marginBottom:2 }}>{d.subject || d.template || "Document"}</div>
              <div style={{ fontSize:11, color:"#9B9690" }}>{d.template} · {fmtDate((d.created_at||"").slice(0,10))}</div>
            </div>
            {d.body && (
              <button className="tp-btn-outline" style={{ fontSize:11, padding:"5px 12px", whiteSpace:"nowrap" }}
                onClick={() => { const w=window.open("","_blank"); w.document.write(`<pre style="font-family:Arial;padding:40px;white-space:pre-wrap;">${d.body}</pre>`); }}>
                View ↗
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

// ── ACCOUNT tab ───────────────────────────────────────────────────────────────
function InpRow({ label, value, onChange, type="text", readOnly=false }) {
  return (
    <div>
      <div className="tp-label" style={{ marginBottom:6 }}>{label}</div>
      <input type={type} value={value} onChange={e => onChange(e.target.value)} readOnly={readOnly}
        className="tp-inp" style={{ background: readOnly ? C.ivory : "#fff", color: readOnly ? "#9B9690" : C.charcoal }}/>
    </div>
  );
}

function AccountTab({ tenant, company, supabase, session, reloadData }) {
  const [name,     setName]    = useState(tenant.name || "");
  const [phone,    setPhone]   = useState(tenant.phone || "");
  const [email,    setEmail]   = useState(tenant.email || "");
  const [saving,   setSaving]  = useState(false);
  const [saved,    setSaved]   = useState(false);
  const [profErr,  setProfErr] = useState("");

  const [pw,       setPw]      = useState("");
  const [pw2,      setPw2]     = useState("");
  const [pwSaving, setPwSaving]= useState(false);
  const [pwDone,   setPwDone]  = useState(false);
  const [pwErr,    setPwErr]   = useState("");

  const saveProfile = async () => {
    setSaving(true); setProfErr(""); setSaved(false);
    const { error } = await supabase.rpc("update_tenant_profile", {
      p_name:  name  || null,
      p_phone: phone || null,
    });
    setSaving(false);
    if (error) { setProfErr(error.message); return; }
    await supabase.auth.updateUser({ data: { full_name: name } });
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
    reloadData();
  };

  const changePassword = async () => {
    setPwErr(""); setPwDone(false);
    if (pw.length < 8) { setPwErr("Password must be at least 8 characters."); return; }
    if (pw !== pw2) { setPwErr("Passwords do not match."); return; }
    setPwSaving(true);
    const { error: upErr } = await supabase.auth.updateUser({ password: pw });
    setPwSaving(false);
    if (upErr) { setPwErr(upErr.message); return; }
    setPw(""); setPw2(""); setPwDone(true);
    setTimeout(() => setPwDone(false), 4000);
  };

  return (
    <div>
      <h2 className="tp-h2">Account</h2>

      {/* Edit profile */}
      <div className="tp-card" style={{ marginBottom:16 }}>
        <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:18, color:C.evergreen, marginBottom:16 }}>Profile</div>
        <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
          <InpRow label="Full Name"    value={name}  onChange={setName}/>
          <InpRow label="Email"        value={email} onChange={setEmail} type="email" readOnly/>
          <InpRow label="Phone Number" value={phone} onChange={setPhone} type="tel"/>
        </div>
        {profErr && <div style={{ marginTop:10, fontSize:13, color:"#dc2626" }}>{profErr}</div>}
        <div style={{ marginTop:16, display:"flex", alignItems:"center", gap:12 }}>
          <button className="tp-btn-green" onClick={saveProfile} disabled={saving}>{saving ? "Saving…" : "Save Profile"}</button>
          {saved && <span style={{ fontSize:13, color:"#22c55e", fontWeight:600 }}>✓ Saved</span>}
        </div>
      </div>

      {/* Change password */}
      <div className="tp-card" style={{ marginBottom:16 }}>
        <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:18, color:C.evergreen, marginBottom:16 }}>Change Password</div>
        <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
          <div>
            <div className="tp-label" style={{ marginBottom:6 }}>New Password</div>
            <input type="password" className="tp-inp" placeholder="At least 8 characters" value={pw} onChange={e => setPw(e.target.value)}/>
          </div>
          <div>
            <div className="tp-label" style={{ marginBottom:6 }}>Confirm Password</div>
            <input type="password" className="tp-inp" placeholder="Re-enter new password" value={pw2} onChange={e => setPw2(e.target.value)}/>
          </div>
        </div>
        {pwErr  && <div style={{ marginTop:10, fontSize:13, color:"#dc2626" }}>{pwErr}</div>}
        {pwDone && <div style={{ marginTop:10, fontSize:13, color:"#22c55e", fontWeight:600 }}>✓ Password updated</div>}
        <button className="tp-btn-green" style={{ marginTop:14 }} onClick={changePassword} disabled={pwSaving}>
          {pwSaving ? "Updating…" : "Update Password"}
        </button>
      </div>

      {/* Tenancy info — read-only */}
      <div className="tp-card" style={{ marginBottom:16 }}>
        <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:18, color:C.evergreen, marginBottom:16 }}>Tenancy Details</div>
        <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
          {[
            ["Property",     tenant.address],
            ["Unit",         tenant.property],
            ["Lease Start",  fmtDate(tenant.lease_start)],
            ["Lease End",    tenant.lease_end ? fmtDate(tenant.lease_end) : "Month-to-Month"],
            ["Monthly Rent", fmtMoney(tenant.rent)],
          ].map(([lbl, val]) => val && val !== "—" ? (
            <div key={lbl} style={{ display:"flex", justifyContent:"space-between", padding:"8px 0", borderBottom:"1px solid #F5F1EA" }}>
              <span style={{ fontSize:12, color:"#9B9690" }}>{lbl}</span>
              <span style={{ fontSize:13, fontWeight:600, color:C.charcoal }}>{val}</span>
            </div>
          ) : null)}
        </div>
      </div>

      {/* Landlord contact */}
      {company && (
        <div className="tp-card">
          <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:18, color:C.evergreen, marginBottom:14 }}>Landlord Contact</div>
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {company.company_name && <div style={{ fontWeight:700, fontSize:14, color:C.charcoal }}>{company.company_name}</div>}
            {company.email && <div style={{ fontSize:13, color:C.charcoal }}>✉ {company.email}</div>}
            {company.phone && <div style={{ fontSize:13, color:C.charcoal }}>📞 {company.phone}</div>}
            {company.address && <div style={{ fontSize:12, color:"#9B9690" }}>{company.address}</div>}
          </div>
        </div>
      )}
    </div>
  );
}
